let productList = [];
let addCartList = [];

var waitForJQuery = setInterval(function () {
    if (typeof $ != 'undefined') {

       let productName = jQuery('.product-single__meta .itemName').text().trim();
      let productId =  jQuery('.product-single__meta .itemId').text().trim();
      let productPrice = jQuery('.product-single__meta .itemPrice').text().trim();
  
      productList.push({
          item_name: productName,
          item_id: productId,
          price: productPrice,
          quantity: 1
      })
  
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
          items: productList
      }
      });
  
      jQuery('.product-single__meta button[type="submit"].add-to-cart').click(function () {
          addCartList = [];  
          addCartList.push({
              item_name: productName,
              item_id: productId,
              price: productPrice,
              quantity: 1
          })
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              event: 'add_to_cart',
              ecommerce: {
                  items: addCartList
              }
          });
      })
      
      clearInterval(waitForJQuery);
    }
}, 10);